import { FC } from "react";
import { Badge } from "@mui/material";
import getPresenceColor from "./presenceColor/getPresenceColor";
import { TBadgeWrapper } from "./Avatar.models";

const BadgeWrapper: FC<TBadgeWrapper> = ({
  employeePresence,
  anchorOrigin,
  dotSize,
  children,
  badgeSx,
}) => {
  if (employeePresence) {
    return (
      <Badge
        sx={{
          ...badgeSx,
          "& .MuiBadge-dot": {
            border: "1px solid white",
            height: dotSize,
            width: dotSize,
            borderRadius: "50%",
          },
        }}
        variant="dot"
        overlap="circular"
        color={getPresenceColor(employeePresence)}
        anchorOrigin={anchorOrigin}
      >
        {children}
      </Badge>
    );
  }

  return children;
};

export default BadgeWrapper;
